import { useQuery } from "@tanstack/react-query";
import { graphqlClient } from "@/lib/graphql";
import { graphql } from "@/__generated__";
import { retryNetworkFailures } from "@/lib/queryClient";

// Real, public marketplace counters for the logged-out homepage (hero stats,
// the "live lessons now" badge, the community count). Pre-seeded during SSR
// (FrontendController + entrypoints/server.tsx) so the above-the-fold numbers
// render in the initial HTML with no hydration flash; cached for 5 min to match
// the server-side PlatformStats cache TTL.
const PLATFORM_STATS_QUERY = graphql(`
  query PlatformStats {
    platformStats {
      activeStudents
      expertTutors
      languages
      liveLessonsNow
      headlineVisible
    }
  }
`);

export function usePlatformStats() {
  const { data, isLoading } = useQuery({
    queryKey: ["platformStats"],
    queryFn: async () => {
      const res = await graphqlClient.request(PLATFORM_STATS_QUERY);
      return res.platformStats;
    },
    staleTime: 5 * 60 * 1000,
    retry: retryNetworkFailures,
  });

  return { stats: data, isLoading };
}
